import script from "./KycRequestsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./KycRequestsScreen.vue?vue&type=script&setup=true&lang=js"

import "./KycRequestsScreen.vue?vue&type=style&index=0&id=74076f3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74076f3e"]])

export default __exports__